import {
  createSlice,
  createAsyncThunk,
  createEntityAdapter,
} from "@reduxjs/toolkit";
import axios from "axios";
import { baseUrl } from "../../../app/constants";

export const premiumTransaction = createAsyncThunk(
  "premiumTransaction/premiumTransaction",
  async ({ uid }) => {
    /// ******** API premium_success_transaction_per_day ********
    const response = await axios.post(
      `${baseUrl}premium_success_transaction_per_day`,
      {
        uid: uid,
      }
    );
    return response.data.response;
  }
);

const changePasswordEntity = createEntityAdapter({
  selectId: (premiumTransaction) => premiumTransaction.id,
});

const changePasswordSlice = createSlice({
  name: "premiumTransaction",
  initialState: changePasswordEntity.getInitialState(),
  extraReducers: {
    [premiumTransaction.pending]: (state) => {
      // console.log('pending')
    },
    [premiumTransaction.fulfilled]: (state, action) => {
      changePasswordEntity.setAll(state, action.payload);
    },
    [premiumTransaction.rejected]: (state) => {
      // console.log("rejected");
    },
  },
});

export const changePasswordSelector = changePasswordEntity.getSelectors(
  (state) => state.premiumTransaction
);
export default changePasswordSlice.reducer;
